import React, { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
const KEY = "jj_cart_v1";

const load = () => {
  try {
    const raw = JSON.parse(localStorage.getItem(KEY)) || [];
    // Migrate legacy single-date items to the range format
    return raw.map((i) => {
      if (i.startDate) return { ...i, days: i.days || 1, endDate: i.endDate || i.startDate };
      return { ...i, startDate: i.date, endDate: i.date, days: 1 };
    });
  } catch { return []; }
};

const sameItem = (i, slug, startDate, endDate) =>
  i.slug === slug && i.startDate === startDate && i.endDate === endDate;

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(load);

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(items)); }, [items]);

  const addItem = (item) => {
    setItems((prev) => {
      if (prev.some((i) => sameItem(i, item.slug, item.startDate, item.endDate))) return prev;
      return [...prev, item];
    });
  };
  const removeItem = (slug, startDate, endDate) =>
    setItems((prev) => prev.filter((i) => !sameItem(i, slug, startDate, endDate)));
  const clear = () => setItems([]);
  const has = (slug, startDate, endDate) => items.some((i) => sameItem(i, slug, startDate, endDate));

  const lineTotal = (i) => (Number(i.price) || 0) * (i.days || 1) + (Number(i.extraVullingen) || 0) * 10;
  const subtotal = items.reduce((s, i) => s + lineTotal(i), 0);

  return (
    <CartContext.Provider value={{ items, addItem, removeItem, clear, has, lineTotal, subtotal, count: items.length }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error("useCart must be used within CartProvider");
  return ctx;
};
